export enum BusinessCompanyRcClaimType {
  VEHICLE = 'VEHICLE',
  MATERIAL = 'MATERIAL',
  BODILY_INJURY = 'BODILY_INJURY',
  OTHER = 'OTHER',
}

export const getBusinessCompanyRcClaimTypeLabel = (object: BusinessCompanyRcClaimType) => {
  switch (object) {
    case BusinessCompanyRcClaimType.VEHICLE:
      return $localize`Véhicule`;
    case BusinessCompanyRcClaimType.MATERIAL:
      return $localize`Matériel`;
    case BusinessCompanyRcClaimType.BODILY_INJURY:
      return $localize`Blessure`;
    case BusinessCompanyRcClaimType.OTHER:
      return $localize`Autre`;
    default:
      return '';
  }
};
